import { Link } from "react-router-dom";
import ComicCard from "@/components/feature/ComicCard";
import { comics } from "@/mocks/data";

export default function FeaturedComics() {
  const featured = [...comics].sort((a, b) => b.views - a.views).slice(0, 8);
  return (
    <section className="bg-background-100" aria-label="热门漫画">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="flex items-end justify-between">
          <div>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">人气热门漫画</h2>
            <p className="mt-2 text-sm text-foreground-600">同好们正在追更的宝藏，安利墙热度实时更新</p>
          </div>
          <Link
            to="/category/kehuan"
            className="hidden items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-800 sm:flex"
          >
            查看更多 <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {featured.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}